export default __webpack_public_path__ + "static/media/52_1_4.c321b05a.png";